import { ExportCSVReport } from '@utils/createCSVReportFile';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { catalogRemoveWorkTypes } from '../catalogTypesWorkQuery';

const requestId = 'useRemoveTypeWork';

export const useRemoveTypeWork = (catalogWorkTypeIds: number[], onRemoveSuccess: () => void) => {
    const dispatch = useDispatch();
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [catalogRemoveWorkTypeReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        setIsSubmitted(false);
        catalogRemoveWorkTypeReset(undefined);

        onRemoveSuccess();
    }, [catalogRemoveWorkTypeReset, onRemoveSuccess]);

    const [
        catalogRemoveWorkTypeData,
        catalogRemoveWorkTypeStatus,
        catalogRemoveWorkTypeError,
        catalogRemoveWorkRequest,
    ] = useRequest({
        requestId,
        query: catalogRemoveWorkTypes,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const catalogRemoveWorkTypeRequest = useCallback(() => {
        setIsSubmitted(true);
        dispatch(catalogRemoveWorkRequest({ catalogWorkTypeIds }));
    }, [catalogRemoveWorkRequest, catalogWorkTypeIds, dispatch]);

    const handleCloseModalError = () => {
        setIsSubmitted(false);
        catalogRemoveWorkTypeReset(undefined);
    };

    const handleCreateReport = () => {
        ExportCSVReport(catalogRemoveWorkTypeData?.catalogRemoveWorkTypes?.validation);
    };

    useEffect(() => {
        catalogRemoveWorkTypeReset(undefined);
    }, [catalogRemoveWorkTypeReset]);

    return {
        catalogRemoveWorkTypeRequest,
        catalogRemoveWorkTypeData,
        catalogRemoveWorkTypeStatus,
        catalogRemoveWorkTypeError,
        isSubmitted,
        handleCloseModalError,
        handleCreateReport,
    };
};
